module.exports = __webpack_public_path__ + "static/media/add-block-below.92db1793.svg";